import { CacheKey } from "@/modules/cache/constants";
import { GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";

export const setMetricsMetadataString = async ({ metadataString }: { metadataString: string }) => {
  await GLOBAL_CACHE_INSTANCE.set(CacheKey.MetricsMetadataString, { metadataString });
};

export const getMetricsMetadataString = async (): Promise<{
  metadataString: string | null;
}> => {
  const cachedData = await GLOBAL_CACHE_INSTANCE.get(CacheKey.MetricsMetadataString, {
    keepInTabMemory: true,
  });

  if (cachedData) {
    return { metadataString: cachedData?.metadataString ?? null };
  }

  return { metadataString: null };
};

export const clearMetricsMetadataString = async () => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.MetricsMetadataString);
};
